import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M7 7h10v3l4-4-4-4v3H5v6h2V7zm10 10H7v-3l-4 4 4 4v-3h12v-6h-2v4z"
}), 'RepeatSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/RepeatSharp.js
// module id = 5751
// module chunks = 2